var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2736 22.4151C32.2736 27.9172 27.6739 32.3774 22 32.3774M32.2736 22.4151C32.2736 16.9131 27.6739 12.4529 22 12.4529M32.2736 22.4151H28.421M22 32.3774C16.3261 32.3774 11.7264 27.9172 11.7264 22.4151M22 32.3774V28.6416M11.7264 22.4151C11.7264 16.9131 16.3261 12.4529 22 12.4529M11.7264 22.4151H15.579M22 12.4529V16.1887",
    stroke: "#00D67C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.98da3fc05ee2378e2b7851c78d507d12.svg";
export { ForwardRef as ReactComponent };